import ConfirmDiscardUnsavedMetaDataModal from '../../MetaData/Modals/ConfirmDiscardUnsavedMetaDataModal';

export const DiscardContractChangesPrompt = ConfirmDiscardUnsavedMetaDataModal;
